import { render, staticRenderFns } from "./PopularCategories.vue?vue&type=template&id=213c3acd&"
import script from "./PopularCategories.vue?vue&type=script&lang=js&"
export * from "./PopularCategories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports